import React from 'react';
import '../../../styles/modes/autoMode.css';

const ModeHelpTooltip = ({ onClose }) => {
  return (
    <div className="mode-help-overlay">
      <div className="mode-help-content">
        <h4>Auto Path Mode Help</h4>
        <button className="close-button" onClick={onClose}>×</button>
        <div className="help-text">
          <p><strong>Purpose:</strong> Automatically solve Transportation Problems using optimization algorithms to find the minimum-cost allocation of goods from supply points to demand points.</p>
          
          <p><strong>Prerequisites:</strong></p>
          <ul>
            <li>Supply and demand points imported in Setup Mode</li>
            <li>At least one supply point and one demand point</li>
            <li>Valid quantities assigned to all points</li>
          </ul>

          <p><strong>Operation Steps:</strong></p>
          <ol>
            <li><strong>Review Location Points:</strong>
              <ul>
                <li>Verify supply and demand points are loaded</li>
                <li>Check quantities are correct</li>
                <li>Points are shown in Location Points list</li>
              </ul>
            </li>
            <li><strong>Select Algorithm:</strong>
              <ul>
                <li>Choose solving method from dropdown menu</li>
                <li>Default is VAM (Vogel's Approximation Method)</li>
                <li>Different algorithms balance speed vs optimality</li>
              </ul>
            </li>
            <li><strong>Solve Transportation Problem:</strong>
              <ul>
                <li>Click "Solve Transport Problem" button</li>
                <li>System automatically:
                  <ul>
                    <li>Calculates distance matrix (real-road distances)</li>
                    <li>Applies selected algorithm</li>
                    <li>Finds optimal allocation</li>
                  </ul>
                </li>
                <li>Results appear automatically</li>
              </ul>
            </li>
            <li><strong>Review Solution:</strong>
              <ul>
                <li>Allocation matrix shows shipment quantities</li>
                <li>Total cost displayed (sum of distance × quantity)</li>
                <li>Routes visualized on map with flow quantities</li>
                <li>Solution details include steps and calculations</li>
              </ul>
            </li>
          </ol>

          <p><strong>Available Algorithms:</strong></p>
          <ul>
            <li><strong>Northwest Corner (NW):</strong>
              <ul>
                <li>Simple heuristic method</li>
                <li>Starts allocation from top-left corner</li>
                <li>Fast but may not be optimal</li>
              </ul>
            </li>
            <li><strong>Least Cost (LC):</strong>
              <ul>
                <li>Greedy approach</li>
                <li>Allocates to lowest cost cells first</li>
                <li>Usually better than NW method</li>
              </ul>
            </li>
            <li><strong>Vogel's Approximation Method (VAM):</strong>
              <ul>
                <li>Advanced heuristic using penalty calculations</li>
                <li>Considers opportunity costs</li>
                <li>Produces near-optimal solutions</li>
              </ul>
            </li>
            <li><strong>VAM + MODI:</strong>
              <ul>
                <li>VAM with Modified Distribution method</li>
                <li>Includes optimality testing and improvement</li>
                <li>Guarantees optimal solution</li>
              </ul>
            </li>
            <li><strong>Linear Programming (LP):</strong>
              <ul>
                <li>Mathematical optimization</li>
                <li>Exact optimal solution</li>
                <li>Best for guaranteed minimum cost</li>
              </ul>
            </li>
          </ul>

          <p><strong>Understanding Results:</strong></p>
          <ul>
            <li><strong>Allocation Matrix:</strong> Shows quantity shipped from each supply to each demand</li>
            <li><strong>Total Cost:</strong> Sum of (distance × quantity) for all shipments</li>
            <li><strong>Route Visualization:</strong> Lines on map showing shipment flows with quantities</li>
            <li><strong>Solution Steps:</strong> Detailed calculation process displayed</li>
            <li><strong>Balanced Problem:</strong> System automatically balances if supply ≠ demand</li>
          </ul>

          <p><strong>Tips:</strong></p>
          <ul>
            <li>Ensure at least 2 points (1 supply + 1 demand) before solving</li>
            <li>VAM+MODI and LP methods produce optimal solutions</li>
            <li>Compare different algorithms to understand trade-offs</li>
            <li>Total supply should approximately equal total demand</li>
            <li>Distance matrix is calculated automatically - no separate step needed</li>
            <li>Check allocation table to verify solution makes sense</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default ModeHelpTooltip; 